import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'online',
  templateUrl: './online.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class OnlineComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null)
  constructor() { }
  ngOnInit(): void {
  }
}